import { 
  MessageSquareQuote, 
  Music, 
  Gift, 
  QrCode, 
  ShieldCheck, 
  Zap 
} from 'lucide-react';
import { Hero } from '../components/landing/Hero';
import { FeatureCard } from '../components/ui/FeatureCard';
import { PricingCard } from '../components/ui/PricingCard';
import { PhysicalGift } from '../components/landing/PhysicalGift';
import { Footer } from '../components/layout/Footer';

export const HomePage = () => {
  return (
    <div className="bg-slate-50 antialiased">
      <Hero />

      <section id="como-funciona" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-3xl md:text-5xl font-black text-slate-900">
              Sua música em <span className="gold-text-gradient">3 passos</span>
            </h2>
            <p className="text-slate-500 text-lg max-w-2xl mx-auto">
              Unimos a sensibilidade humana à potência da inteligência artificial para criar algo eterno.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <FeatureCard 
              step="01"
              icon={MessageSquareQuote} 
              title="Conte sua história" 
              description="Envie detalhes, apelidos e momentos marcantes através do nosso formulário inteligente." 
            />
            <FeatureCard 
              step="02"
              icon={Music} 
              title="Escolha o estilo" 
              description="Do MPB ao Rock, nossa IA compõe a letra e a melodia baseada na emoção do seu relato." 
            />
            <FeatureCard 
              step="03"
              icon={Gift} 
              title="Receba a magia" 
              description="Acesse sua música digitalmente ou receba o porta-retrato exclusivo em sua casa." 
            />
          </div>
        </div>
      </section>

      <PhysicalGift />

      <section id="estilos" className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black mb-4">Pronto para emocionar?</h2>
          <p className="text-slate-500">Escolha o plano que melhor se adapta à sua homenagem.</p>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 px-6">
          <PricingCard 
            title="Homenagem Avulsa"
            price="R$ 9,90"
            description="Envio rápido e digital para surpreender agora."
            features={[
              "Música em alta fidelidade",
              "Letra personalizada pela IA",
              "Capa de álbum digital",
              "Entrega em até 24h"
            ]}
          />
          <PricingCard 
            featured
            title="Plano Premium"
            price="R$ 29,90"
            description="O presente físico que dura para sempre."
            features={[
              "Tudo do plano Digital",
              "Porta-retrato físico premium",
              "QR Code gravado a laser",
              "Frete grátis para todo Brasil",
              "Prioridade na fila de criação"
            ]}
          />
        </div>
      </section>

      <Footer />
    </div>
  );
};